<script>
  import ImageProc from "./ImageProc.js";
  import Share from "./Share.svelte";

  let canViewResult = false;
  let resultDataUrl;

  const biscuitSize = {
    width: 350,
    height: 450,
  };

  const readFile = (files) => {
    if (!files || files.length === 0) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      const dataUrl = reader.result;
      document.getElementById("src").src = dataUrl;
      document.getElementById("src").onload = () => {
        generate();
      };
    };
  };

  const generate = () => {
    const frame = document.getElementById("frame");
    const frameCnv = document.getElementById("frameCnv");
    const frameCnvCtx = frameCnv.getContext("2d");
    frameCnv.width = frame.width;
    frameCnv.height = frame.height;
    frameCnvCtx.drawImage(frame, 0, 0);
    const src = document.getElementById("src");
    const srcCnv = document.getElementById("srcCnv");
    const srcCnvCtx = srcCnv.getContext("2d");
    const srcSize = adjustImageSize(src.width, src.height);
    console.log(srcSize);
    srcCnv.width = srcSize.width;
    srcCnv.height = srcSize.height;
    srcCnvCtx.drawImage(
      src,
      0,
      0,
      src.width,
      src.height,
      0,
      0,
      srcSize.width,
      srcSize.height
    );

    const thresCnv = document.getElementById("thresCnv");
    const thresCnvCtx = thresCnv.getContext("2d");
    thresCnv.width = srcCnv.width;
    thresCnv.height = srcCnv.height;
    ImageProc.threshold(srcCnvCtx, thresCnvCtx, srcCnv.width, srcCnv.height);

    const dstCnv = document.getElementById("dstCnv");
    const dstCnvCtx = dstCnv.getContext("2d");
    dstCnv.width = frame.width;
    dstCnv.height = frame.height;

    dstCnvCtx.drawImage(frame, 0, 0);
    const drawImagePosition = calcDrawImagePosition(
      srcSize.width,
      srcSize.height
    );
    ImageProc.draw(thresCnv, dstCnv, drawImagePosition);
    resultDataUrl = dstCnv.toDataURL();
    canViewResult = true;
  };

  const adjustImageSize = (width, height) => {
    const size = { width, height };
    console.log(size);
    if (size.width > size.height) {
      size.height *= biscuitSize.width / size.width;
      size.width = biscuitSize.width;
    } else {
      size.width *= biscuitSize.height / size.height;
      size.height = biscuitSize.height;
    }

    return size;
  };

  const calcDrawImagePosition = (width, height) => {
    const position = {
      x: Math.trunc((biscuitSize.width - width) / 2 + 240),
      y: Math.trunc((biscuitSize.height - height) / 2 + 315),
    };
    return position;
  };
</script>

<div class="parent">
  <div class="main">
    <h3>ビスケットジェネレーター</h3>
    <p class="description">好きな画像をビスケットの柄にできるぞ！</p>
    <span class="caution">(画像はどこにもアップロードされません)</span>
    <img id="frame" class="hidden" src="/assets/biscuit.png" alt="img" />
    <img id="src" class="hidden" alt="img" />
    <canvas id="frameCnv" class="hidden" />
    <canvas id="srcCnv" class="hidden" />
    <canvas id="thresCnv" class="hidden" />
    <div class={canViewResult ? "result" : "hidden"}>
      <canvas id="dstCnv" />
      <Share image={resultDataUrl} />
    </div>

    <input
      type="file"
      accept="image/*"
      on:change={(e) => {
        readFile(e.target.files);
      }}
    />
  </div>
  <hr />
  <div class="material">
    使用素材：
    <a
      href="https://publicdomainq.net/biscuits-thanks-0050067/"
      target="_blank"
      rel="noopener noreferrer"
    >
      ビスケットの「THANKS」
    </a>
  </div>
  <hr />
  <footer class="copyright">
    © 2021
    <a
      href="https://twitter.com/de_teiu_tkg"
      target="_blank"
      rel="noopener noreferrer"
    >
      @de_teiu_tkg
    </a>
  </footer>
</div>

<style>
  .parent {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .result {
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #dstCnv {
    width: 95%;
    max-width: 460px;
    position: relative;
    z-index: 100;
  }

  .description {
    margin-bottom: 0px;
  }
  .caution {
    font-size: 0.8em;
    margin-bottom: 10px;
  }
</style>
